import { Trans } from "@lingui/react/macro";
import styles from "./UnreadMessageBannerContent.module.scss";
import { Text } from "@medoma/components/Text/Text";
import ChatConversationIcon from "@medoma/components/icons/ChatConversation";
import { NotificationCircle } from "@medoma/components/NotificationCircle/NotificationCircle";

export const UnreadMessageBannerContent = ({
  hasUnreadNotification,
}: {
  hasUnreadNotification: boolean;
}) => {
  return hasUnreadNotification ? (
    <div className={styles.unreadMessageBannerContent}>
      <NotificationCircle isVisible>
        <ChatConversationIcon />
      </NotificationCircle>
      <Text element="div">
        <Trans>Du har ett oläst meddelanden i chatten</Trans>
      </Text>
      <Text element="div" weight="bold">
        <Trans>Visa</Trans>
      </Text>
    </div>
  ) : null;
};
